import React, { useRef, useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import { Skeleton, Form, Radio, Button, message, Modal, Input } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { UPLOADS, SETTINGS_APP } from '../../params';
import { getSurveysId, getSurveysList, addSurveysPassing, addSurveysPassingConsult } from '../../API/surveys';
import { Error404_Component } from "../errors/404";
import { setSurveys_id } from "../../redux/surveys/reducer";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import MaskedInput from 'react-text-mask';
import emailMask from 'text-mask-addons/dist/emailMask';
import users from '../header/users';
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
SwiperCore.use([Autoplay, Navigation, Pagination]);

import edjsParser from 'editorjs-parser';
const parser = new edjsParser();
import parse from 'html-react-parser';

export const Survey = props => {
    
    const dispatch = useDispatch();
    const location = useLocation();
    const app_global = useSelector(state => state.app_global);
    const profile = useSelector(state => state.profile);
    const surveys = useSelector(state => state.surveys);
    const [activeModal, setActiveModal] = useState("");
    
    const [form_surveys_passing] = Form.useForm();
    const [form_surveys_passing_consult] = Form.useForm();
    
    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const params = useParams();

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

        }
    }, []);

    useEffect(async () => {
        await component_start();
    }, [location]);

    useEffect(async () => {
        component_start()
    }, [profile.token]);

    async function component_start() {
        
        dispatch(setSurveys_id({}));

        await getSurveysId({
            id: params.surveysID,
        },dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [getSurveysId]`, `color: #A366FF`, json );

            if (json?.code) {
                if (json?.result) {
                    //Done
                }
            }
        });

        await getSurveysList({
            category: 1
        },dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [getSurveysList]`, `color: #A366FF`, json );
            if (json?.code) {
                //Done
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });
    }

    // Отправка формы результата опроса
    async function form_finish_surveys_passing(v) {
        v['id'] = surveys.surveys_id.id;
        
        await addSurveysPassing(v,dispatch)
        .then(async json => {
            console.log ( `%c [API]: [addSurveysPassing]`, `color: #A366FF`, json );
            if (json?.code) {
                form_surveys_passing.resetFields();
                message.success('Результаты получены!');
                setTimeout(() => {
                    if (activeModal !== 'form_passing') {
                        showModalPassing()
                    }
                }, 5000)
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });
    }

    //* Окно заявки
    async function showModalPassing() {
        form_surveys_passing_consult.setFieldsValue({
            firstname: '',
            lastname: '',
            phone: '',
            email: '',
        });
        setActiveModal('form_passing');
    }

    async function closeModalPassing() {
        await setActiveModal('');
        await form_surveys_passing_consult.resetFields();
    }

    //* Отправка заявки
    async function form_finish_surveys_passing_consult(v) {
        v['phone'] = Number((v['phone']).replace(/\D+/g,""));
        v['passing_id'] = surveys.passing_id.id;
        await addSurveysPassingConsult(v,dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [addSurveysPassingConsult]`, `color: #A366FF`, json );
            if (json?.code) {
                closeModalPassing();
                message.success('Заявка отправлена!');
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });
    }

    var obj = {
        get surveys_list () {
            if ( surveys.surveys_list.length > 0 ) {
                return surveys.surveys_list.filter( function( item ) {
                    return(
                        item['id'] !== params.surveysID
                    );
                } ).slice(0, 4);
            } else {
                return surveys.surveys_list.slice(0, 4);
            }
        },
    };

    const randomUser = users[Math.floor(Math.random() * (users.length - 0)) + 0];

    return (
        <>
            {
                app_global.loading ?
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                Object.keys(surveys.surveys_id).length > 0 ?
                surveys.surveys_id.error_code === 404 ?
                    <Error404_Component />
                :
                    <>
                        <Helmet>
                            <title>{`${ surveys.surveys_id.seo_title } - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения`}</title>
                            <meta property='og:title' content={`${ surveys.surveys_id.seo_title } - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения`} />
                            <meta name="description" content={`${ surveys.surveys_id.seo_description !== null ? surveys.surveys_id.seo_description : '' }`} />
                            <meta name="og:description" content={`${ surveys.surveys_id.seo_description !== null ? surveys.surveys_id.seo_description : '' }`} />
                            <meta name="keywords" content={`${ surveys.surveys_id.seo_keywords !== null ? surveys.surveys_id.seo_keywords : '' }`} />
                        </Helmet>
                        <Modal mask centered className="modal_custom modal_authorization" key="m_form_passing" width={700} title="Заявка на консультацию" open={activeModal === 'form_passing'} onOk={() => closeModalPassing()} onCancel={() => closeModalPassing()} footer={null}>
                            <div className='header'>
                                <h2>Заявка</h2>
                                <h3>на консультацию</h3>
                            </div>
                            <div className="custom_divider"></div>
                            <div className='body'>
                                <Form name="form" className="form" form={form_surveys_passing_consult} onFinish={form_finish_surveys_passing_consult}>
                                    <label>Имя</label>
                                    <Form.Item name={`firstname`} rules={[{ required: true, message: `Пожалуйста, введите Ваше имя!` }]}>
                                        <Input disabled={surveys.loading} className='custom_input' placeholder={randomUser['firstname']} />
                                    </Form.Item>
                                    <label>Фамилия</label>
                                    <Form.Item name={`lastname`} >
                                        <Input disabled={surveys.loading} className='custom_input' placeholder={randomUser['lastname']} />
                                    </Form.Item>
                                    <label>Телефон</label>
                                    <Form.Item name={`phone`} rules={[{ required: true, message: `Пожалуйста, введите номер телефона!` }]}>
                                        <MaskedInput
                                            disabled={surveys.loading}
                                            mask={SETTINGS_APP.mask[SETTINGS_APP.project_format]['account']}
                                            placeholder={SETTINGS_APP.mask[SETTINGS_APP.project_format]['placeholder']}
                                            render={(ref, props) => (
                                                <input className="ant-input custom_input" type="text" aria-required="true" ref={ref} {...props} />
                                            )}
                                        />
                                    </Form.Item>
                                    <label>E-mail</label>
                                    <Form.Item name={`email`} >
                                        <MaskedInput
                                            disabled={surveys.loading}
                                            mask={emailMask}
                                            placeholder="mail@52c.ru"
                                            render={(ref, props) => (
                                                <input className="ant-input custom_input" type="text" aria-required="true" ref={ref} {...props} />
                                            )}
                                        />
                                    </Form.Item>
                                    <div className='form_buttons'>
                                        <Button className='submit' htmlType="submit" loading={surveys.loading}>Оставить заявку</Button>
                                    </div>
                                </Form>
                            </div>
                            <div className='footer'>
                                
                            </div>
                        </Modal>
                        <section className='container_full --survey'>
                            <section className='top'>
                                <section className='container shadow default_padding'>
                                    <h1>{surveys.surveys_id?.title}</h1>
                                </section>
                            </section>
                            <section className='body'>
                                <section className='container shadow default_padding'>
                                    <section className='left'>
                                        <p className='title'>Рекомендуемые опросы</p>
                                        <p className='excerpt'>Так же вы можете пройти другие опросы на нашем портале, чтобы понять узнать текущее состояние вашего здоровья</p>
                                        {obj.surveys_list ? 
                                            <>
                                                <div className='slider_pc'>
                                                {
                                                    obj.surveys_list.map((item) => 
                                                        <Link to={`/surveys/${item?.id}`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                            <div className='article_background'>
                                                                {item.photo_mini === null ? 
                                                                    null
                                                                :
                                                                    <img src={`${UPLOADS}/${item.photo_mini}`} />
                                                                }
                                                            </div>
                                                            <div className='article_column'>
                                                                <div className='article_column_left'>
                                                                    <div className='article_title'>{item?.seo_title}</div>
                                                                    <div className='article_excerpt'>{item?.excerpt}</div>
                                                                </div>
                                                                <div className='article_column_right'>
                                                                    <span></span>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    )
                                                }
                                                </div>
                                                <div className='slider_mob'>
                                                    <Swiper
                                                        loop
                                                        spaceBetween={12}
                                                        slidesPerView={1.5}
                                                        pagination={{
                                                            type: "progressbar",
                                                        }}
                                                        navigation={{
                                                            prevEl: navigationPrevRef.current,
                                                            nextEl: navigationNextRef.current,
                                                        }}
                                                        onBeforeInit={(swiper) => {
                                                            swiper.params.navigation.prevEl = navigationPrevRef.current;
                                                            swiper.params.navigation.nextEl = navigationNextRef.current;
                                                        }}
                                                        breakpoints={{
                                                            992: {
                                                                slidesPerView: 2.75,
                                                            },
                                                            991: {
                                                                slidesPerView: 2,
                                                            },
                                                            700: {
                                                                slidesPerView: 1.5,
                                                            },
                                                        }}
                                                    >
                                                        {
                                                            surveys.surveys_list.slice(0, 4).map((item) => 
                                                                <SwiperSlide>
                                                                    <Link to={`/surveys/${item?.id}`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                                        <div className='article_background'>
                                                                            {item.photo_mini === null ? 
                                                                                null
                                                                            :
                                                                                <img src={`${UPLOADS}/${item.photo_mini}`} />
                                                                            }
                                                                        </div>
                                                                        <div className='article_column'>
                                                                            <div className='article_column_left'>
                                                                                <div className='article_title'>{item?.seo_title}</div>
                                                                                <div className='article_excerpt'>{item?.excerpt}</div>
                                                                            </div>
                                                                            <div className='article_column_right'>
                                                                                <span></span>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </SwiperSlide>
                                                            )
                                                        }
                                                    </Swiper>
                                                </div>
                                            </>
                                        :
                                            <div className='article'>
                                                <div className='article_column'>
                                                    <div className='article_column_left'>
                                                        <div className='article_title'><Skeleton.Button style={{marginBottom: '5px', maxWidth: '200px'}} size="small" shape="round" active block /></div>
                                                        <div className='article_excerpt'><Skeleton.Button style={{marginBottom: '5px', maxWidth: '150px'}} size="small" shape="round" active block /></div>
                                                    </div>
                                                    <div className='article_column_right'>
                                                        <span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </section>
                                    <section className='right'>
                                        <div className='content'>
                                            <div className='header'>
                                                {surveys.surveys_id?.photo_big === null ?
                                                    null
                                                :
                                                    <div className='posts_image_big'>
                                                        <img src={`${UPLOADS}/${surveys.surveys_id?.photo_big}`} />
                                                    </div>
                                                }
                                            </div>

                                            <div className='body'>
                                                <h2>{surveys.surveys_id?.seo_title}</h2>
                                                {surveys.surveys_id?.content !== '{}' ?
                                                    Object.keys(JSON.parse(surveys.surveys_id?.content)).length > 0 ?
                                                        JSON.parse(surveys.surveys_id?.content)?.blocks.length > 0 ?
                                                            <div className='text_content'>
                                                                {parse(parser.parse(JSON.parse(surveys.surveys_id?.content)))}
                                                            </div>
                                                        :
                                                            null
                                                    :
                                                        null
                                                :
                                                    null
                                                }
                                                {Object.keys(surveys.passing_id).length ? 
                                                    surveys.passing_id?.content !== '{}' ?
                                                        Object.keys(JSON.parse(surveys.passing_id?.content)).length > 0 ?
                                                            JSON.parse(surveys.passing_id?.content)?.blocks.length > 0 ?
                                                                <>
                                                                    <div className='text_content text_result'>
                                                                        {parse(parser.parse(JSON.parse(surveys.passing_id?.content)))}
                                                                    </div>
                                                                    {(surveys.surveys_id?.specialization_id || surveys.surveys_id?.symptom_id) ? 
                                                                        <div className="fcenter" style={{marginTop:20}}>
                                                                            {surveys.surveys_id?.specialization_id ? 
                                                                                <Link to={`/specializations/${surveys.surveys_id?.specialization_id}`} exact={ true } onClick={() => scroll.scrollToTop()} className="submit_mini_white" >Советы специалиста</Link>
                                                                            :
                                                                                null
                                                                            }
                                                                            {surveys.surveys_id?.symptom_id ? 
                                                                                <Link to={`/symptoms/${surveys.surveys_id?.symptom_id}`} exact={ true } onClick={() => scroll.scrollToTop()} className="submit_mini" >Симптомы для обращения к специалисту</Link>
                                                                            :
                                                                                null
                                                                            }
                                                                        </div>
                                                                    :
                                                                        null
                                                                    }
                                                                    <div className="fcenter" style={{marginTop:20}}>
                                                                        <Button className="submit_mini" onClick={() => showModalPassing()}>Оставить заявку на консультацию</Button>
                                                                    </div>
                                                                </>
                                                            :
                                                                null
                                                        :
                                                            null
                                                    :
                                                        null
                                                :
                                                    null
                                                }

                                                {!Object.keys(surveys.passing_id).length ?
                                                    <Form name="form" className="default_form" form={form_surveys_passing} onFinish={form_finish_surveys_passing}>
                                                        <ol>
                                                            {surveys.surveys_id?.questions.map((question) => 
                                                                <li>
                                                                    <label>{question?.text}</label>
                                                                    <Form.Item name={`question_${question?.id}`} rules={[{ required: true, message: `Пожалуйста, ответьте на вопрос!` }]}>
                                                                        <Radio.Group className='custom_radio' disabled={surveys.loading} options={question?.answers} optionType="button" />
                                                                    </Form.Item>
                                                                </li>
                                                            )}
                                                        </ol>
                                                        <div className='form_buttons'>
                                                            <Button className='submit' htmlType="submit" loading={surveys.loading}>Узнать результат</Button>
                                                        </div>
                                                    </Form>
                                                :
                                                    null
                                                }
                                            </div>
                                        </div>
                                    </section>
                                </section>
                            </section>
                        </section>
                    </>
                :
                    <section className='container shadow default_padding marginTop'>
                        <div className='content'>
                            <Skeleton active />
                        </div>
                    </section>
            }
        </>
    );
};